var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { View } from "./view";
import LocalStorageService from "../../services/localStorage";
import { useRegionGetAll } from "../../fnx/region/regionGetAll";
import { useRegionPatch } from "../../fnx/region/regionPatch";
import { useRegionPost } from "../../fnx/region/regionPost";
import { deleteEntity, deleteEntityClearData, } from "../../store/delete/actions";
import { regionClearData, regionPatchClearData, regionPostClearData, } from "../../store/region/actions";
import { Columns, dataFormRegion } from "./regionDTO";
import { icons, typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import showToast from "../../services/toast";
import { AlertLoadingHeader } from "../../components/alertLoadingComponent/alertLoading";
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
export var RegionAdmin = function () {
    var dispatch = useDispatch();
    var _a = useState([]), list = _a[0], setList = _a[1];
    var level1 = "REGION_LEVEL1";
    var level2 = "REGION_LEVEL2";
    var level3 = "REGION_LEVEL3";
    var _b = useState(level1), levelForm = _b[0], setLevelForm = _b[1];
    var _c = useState(false), trigger = _c[0], setTrigger = _c[1];
    var _d = useState(false), triggerPost = _d[0], setTriggerPost = _d[1];
    var _e = useState(false), triggerPatch = _e[0], setTriggerPatch = _e[1];
    var _f = useState(false), openModalDelete = _f[0], setOpenModalDelete = _f[1];
    var _g = useState(""), nameSearch = _g[0], setNameSearch = _g[1];
    var _h = useState({ data: {} }), bodyRequest = _h[0], setBodyRequest = _h[1];
    var _j = useState(1), page = _j[0], setPage = _j[1];
    var _k = useState(100), limit = _k[0], setLimit = _k[1];
    var _l = useState(0), countPagination = _l[0], setCountPagination = _l[1];
    var clientId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var branchId = React.useState(lsLogin.getUserLoginStored().branchId)[0];
    var _m = useState(null), treePrevious = _m[0], setTreePrevious = _m[1];
    var _o = useState(false), isUpdate = _o[0], setIsUpdate = _o[1];
    var _p = useState(false), openDrawer = _p[0], setOpenDrawer = _p[1];
    var _q = useState(null), itemModal = _q[0], setitemModal = _q[1];
    var _r = useState(dataFormRegion), dataForm = _r[0], setDataForm = _r[1];
    var _s = useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _s[0], setSeeToast = _s[1];
    var _t = useState(null), regionOptions1 = _t[0], setRegionOptions1 = _t[1];
    var _u = useState([]), treeData = _u[0], setTreeData = _u[1];
    var _v = useState([]), parentLevel = _v[0], setParentLevel = _v[1];
    var _w = useState(null), parentRegionOptions = _w[0], setParentRegionOptions = _w[1];
    var regionLevelOptions = [
        { id: 1, name: "Provincia", value: "REGION_LEVEL1" },
        {
            id: 2,
            name: "Municipio",
            value: "REGION_LEVEL2",
        },
        { id: 3, name: "Sector", value: "REGION_LEVEL3" },
    ];
    var _x = useState(null), breadcrumb = _x[0], setBreadcrumb = _x[1];
    //trigger  name  zipcode  code: string,  type: Level,  parentRegionId: number,  clientId: string,35b1cb75-8bba-4b03-bcea-6413661b870a"
    var _y = useRegionGetAll(trigger, nameSearch, "", "", levelForm, parentLevel[0] ? parentLevel[parentLevel.length - 1].value : "", clientId, page, limit), responseRegion = _y.responseRegion, errorRegion = _y.errorRegion, loadingRegion = _y.loadingRegion;
    //const { responseRegionOne, errorRegionOne, loadingRegionOne } = useGetRegion(triggerOne,parentLevel.value || "" );
    var _z = useRegionPost(triggerPost, bodyRequest), responsePostRegion = _z.responsePostRegion, errorPostRegion = _z.errorPostRegion, loadingPostRegion = _z.loadingPostRegion;
    var _0 = useRegionPatch(triggerPatch, bodyRequest), responsePatchRegion = _0.responsePatchRegion, errorPatchRegion = _0.errorPatchRegion, loadingPatchRegion = _0.loadingPatchRegion;
    var _1 = useSelector(function (state) { return ({
        responseDeleteEntity: state.DeleteEntity.responseDeleteEntity,
        loadingDeleteEntity: state.DeleteEntity.loadingDeleteEntity,
        errorDeleteEntity: state.DeleteEntity.errorDeleteEntity,
    }); }), responseDeleteEntity = _1.responseDeleteEntity, loadingDeleteEntity = _1.loadingDeleteEntity, errorDeleteEntity = _1.errorDeleteEntity;
    useEffect(function () {
        if (!responseRegion) {
            setLevelForm(level1);
            setTrigger(true);
        }
    }, []);
    useEffect(function () {
        var _a;
        if (responseRegion && (responseRegion === null || responseRegion === void 0 ? void 0 : responseRegion.data)) {
            setCountPagination(responseRegion === null || responseRegion === void 0 ? void 0 : responseRegion.pagingInfo.totalItems);
            var data = (_a = responseRegion.data) === null || _a === void 0 ? void 0 : _a.map(function (region) {
                return {
                    id: region.id,
                    title: region.name,
                    code: region.code,
                    zipcode: region.zipcode,
                    parentId: region.parentRegionId,
                    clientId: region.clientId,
                    name: region.name,
                    parent: region.parentRegionId,
                    level: region.type,
                };
            });
            var tree = responseRegion.data.map(function (item) {
                var _a;
                return {
                    name: item.name,
                    nameLower: (_a = item.name) === null || _a === void 0 ? void 0 : _a.toLowerCase(),
                    parent: item.parentRegionId,
                    children: null,
                    id: item.id,
                    folder: true,
                    level: item.type,
                };
            });
            if (responseRegion.level === level1) {
                setParentLevel([]);
                setBreadcrumb([
                    {
                        name: "",
                        ariaCurrent: "",
                        key: "",
                    },
                ]);
            }
            setRegionOptions1(data);
            if (nameSearch === "")
                setTreeData({ data: tree });
            var list_1 = responseRegion.data.map(function (item) { return ({
                id: item.id,
                Code: item.code,
                Name: item.name,
                ZipCode: item.zipcode,
                RegionPadre: "",
                RegionType: item.type,
            }); });
            setList(list_1);
        }
        setTrigger(false);
        dispatch(regionClearData());
    }, [responseRegion]);
    useEffect(function () {
        if (errorRegion) {
            setTrigger(false);
        }
    }, [errorRegion]);
    useEffect(function () {
        var _a, _b, _c;
        if (responsePostRegion) {
            setSeeToast({
                show: true,
                message: "Creado con éxito",
                type: typeAlert.success,
            });
            setOpenDrawer(false);
            setTriggerPost(false);
            setTrigger(true);
        }
        else if (errorPostRegion) {
            var error = errorPostRegion;
            var message = "Error al crear";
            if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.errors) !== undefined) {
                message = (_b = error.response) === null || _b === void 0 ? void 0 : _b.errors[0].message;
            }
            else {
                message = (_c = error.response) === null || _c === void 0 ? void 0 : _c.message;
            }
            setSeeToast({
                show: true,
                message: message,
                type: typeAlert.error,
            });
            setTriggerPost(false);
            setTrigger(false);
        }
        dispatch(regionPostClearData());
    }, [responsePostRegion, errorPostRegion]);
    useEffect(function () {
        if (responseDeleteEntity) {
            setSeeToast({
                show: true,
                message: "Eliminado con éxito",
                type: typeAlert.success,
            });
            setOpenDrawer(false);
            setOpenModalDelete(false);
            dispatch(deleteEntityClearData());
            setTrigger(true);
        }
        else if (errorDeleteEntity) {
            setSeeToast({
                show: true,
                message: errorDeleteEntity === null || errorDeleteEntity === void 0 ? void 0 : errorDeleteEntity.message.message,
                type: typeAlert.error,
            });
        }
    }, [responseDeleteEntity, errorDeleteEntity]);
    useEffect(function () {
        if (responsePatchRegion) {
            setSeeToast({
                show: true,
                message: "Actualizado con éxito",
                type: typeAlert.success,
            });
            setOpenDrawer(false);
            setTriggerPatch(false);
            setTrigger(true);
        }
        else if (errorPatchRegion) {
            setSeeToast({
                show: true,
                message: errorPatchRegion === null || errorPatchRegion === void 0 ? void 0 : errorPatchRegion.message,
                type: typeAlert.error,
            });
            setTriggerPatch(false);
        }
        dispatch(regionPatchClearData());
    }, [responsePatchRegion, errorPatchRegion]);
    var searchFilter = function (term) {
        setNameSearch(term);
    };
    useEffect(function () {
        if (nameSearch) {
            setTrigger(true);
        }
        else {
            onCloseSearch();
        }
    }, [nameSearch]);
    var onCloseSearch = function () {
        setNameSearch("");
        setTrigger(true);
    };
    var filterStatus = function (item) {
        // const idUser = item?.user.map((item: any) => item.id).join(",");
        // setTrigger(true);
    };
    var showEdit = function (row) {
        setDataForm(__assign(__assign({}, dataForm), { id: row.id, Code: row.code, Name: row.name, Zipcode: row.zipcode, RegionType: row.level, ParentRegion: row.parentId }));
    };
    var handleSubmit = function (dataItem) {
        if (isUpdate) {
            setBodyRequest({
                data: {
                    id: dataItem.id,
                    name: dataItem.Name,
                    zipcode: dataItem.Zipcode,
                    code: dataItem.Code,
                    parentRegionId: dataItem.ParentRegion,
                    type: dataItem.RegionType,
                },
            });
            setTriggerPatch(true);
        }
        else {
            setBodyRequest({
                data: __assign({ name: dataItem.Name, zipcode: dataItem.Zipcode, code: dataItem.Code, type: dataItem.RegionType }, (dataItem.RegionType === level1
                    ? {}
                    : { parentRegionId: dataItem.ParentRegion })),
            });
            setTriggerPost(true);
        }
        setOpenDrawer(false);
    };
    var handleCloseModal = function () {
        setOpenDrawer(false);
        setDataForm(__assign(__assign({}, dataForm), { id: "", Code: "", Name: "", Zipcode: "", RegionType: "", ParentRegion: "" }));
    };
    var handleChangeRegionType = function (value) {
        /* if (value === "REGION_LEVEL1") {
               setParentRegionOptions(null);
             } else if (value === "REGION_LEVEL2") {
               setParentRegionOptions(regionOptions1);
             } else if (value === "REGION_LEVEL3") {
               setParentRegionOptions(regionOptions2);
             }*/
    };
    //const handleChangeSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    var handleSelectChange = function (event) {
        var _a = event.target, value = _a.value, name = _a.name;
        if (name === "RegionType") {
            handleChangeRegionType(value);
        }
        else if (name === "a") {
        }
    };
    var handleOnClickAdd = function () {
        setIsUpdate(false);
        setOpenDrawer(true);
        setDataForm(__assign(__assign({}, dataForm), { id: "", Code: "", Name: "", Zipcode: "", RegionType: levelForm, ParentRegion: parentLevel.length > 0 ? parentLevel[parentLevel.length - 1].id : "" }));
    };
    var onClickContextMenu = function (opt, item) {
        if (opt.id === "1") {
            showEdit(item);
            setIsUpdate(true);
            setOpenDrawer(true);
        }
        else if (opt.id === "2") {
            setitemModal(item);
            setOpenModalDelete(true);
        }
        else if (opt.id === "3") {
            setitemModal(item);
        }
    };
    var clickView = function (view) {
        setitemModal(view);
    };
    var handleDelete = function () {
        setOpenModalDelete(false);
        dispatch(deleteEntity({
            id: itemModal === null || itemModal === void 0 ? void 0 : itemModal.id,
            entity: "RegionEntity",
            idUser: clientId,
        }));
    };
    var ColumnsRegion = Columns(onClickContextMenu);
    var buttonActionOptions = [
        {
            icons: icons.Menu,
            id: "1",
            name: "editar",
        },
        {
            icons: icons.Menu,
            id: "2",
            name: "eliminar",
        },
        {
            icons: icons.Menu,
            id: "3",
            name: "clonar",
        },
    ];
    var handleOnClickBreadcrumb = function (item) {
        console.log("handleOnClickBreadcrumb", item);
    };
    var handleClickTree = function (item) {
        setNameSearch("");
        if (item === null || item === void 0 ? void 0 : item.value) {
            var itemRegion_1 = regionOptions1.filter(function (i) { return i.id === item.value; });
            if (itemRegion_1[0].level === level1 || itemRegion_1[0].level === level2) {
                itemRegion_1[0].value = item.value;
                setTreePrevious(itemRegion_1);
                var bc = __spreadArray([], breadcrumb, true);
                var found = breadcrumb.some(function (el) { return el.key === itemRegion_1[0].id; });
                if (!found) {
                    bc.push({
                        name: itemRegion_1[0].title,
                        ariaCurrent: itemRegion_1[0].level,
                        key: itemRegion_1[0].id,
                    });
                }
                setBreadcrumb(bc);
                var pl = __spreadArray([], parentLevel, true);
                pl.push(itemRegion_1[0]);
                setParentLevel(pl);
                if (itemRegion_1[0].level === level1) {
                    setLevelForm(level2);
                }
                if (itemRegion_1[0].level === level2) {
                    setLevelForm(level3);
                }
                setTrigger(true);
            }
            else {
                console.log("No se puede seleccionar un sector", itemRegion_1[0].level);
            }
        }
    };
    var handleClickBack = function (item) {
        setNameSearch("");
        var pl = __spreadArray([], parentLevel, true);
        pl.pop();
        setParentLevel(pl);
        //setParentLevel(item);
        var bc = __spreadArray([], breadcrumb, true);
        bc.pop();
        setBreadcrumb(bc);
        if (levelForm === level2) {
            setLevelForm(level1);
        }
        else if (levelForm === level3) {
            setLevelForm(level2);
        }
        setTrigger(true);
    };
    var onChangeRowsPerPage = function (e) {
        setLimit(e);
        setTrigger(true);
    };
    var onChangePage = function (e) {
        setPage(e);
        setTrigger(true);
    };
    return (_jsxs(React.Fragment, { children: [_jsx(AlertLoadingHeader, { loading: loadingRegion ||
                    loadingPostRegion ||
                    loadingPatchRegion ||
                    loadingDeleteEntity, seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast, titleLoading: loadingRegion ||
                    loadingPostRegion ||
                    loadingPatchRegion ||
                    loadingDeleteEntity
                    ? "Eliminando region"
                    : "Cargando regiones..." }), _jsx(View
            // Props Admin
            , { 
                // Props Admin
                title: "Regiones", columns: regionOptions1 || [], onClickBreadcrumb: handleOnClickBreadcrumb, buttonTextAdd: "Agregar region", onChangeSelect: handleSelectChange, onClickAdd: handleOnClickAdd, parentLevel: parentLevel, buttonActionOptions: buttonActionOptions, onClickTree: handleClickTree, onClickBackTree: handleClickBack, breadcrumb: breadcrumb, treePrevious: parentLevel[0] ? [parentLevel[parentLevel.length - 1]] : [], 
                // Props Form
                titleForm: "Edici\u00F3n de region", dataForm: dataForm, editMode: false, buttonText: "Guardar", RegionTypeOptions: regionLevelOptions, ParentRegionTypeOptions: parentRegionOptions, onSaveData: handleSubmit, 
                // Props Drawer
                openDrawer: openDrawer, textDescription: "Por favor, ingrese los datos de las regiones. Estas son fundamentales para proporcionar informaci\u00F3n precisa sobre la geograf\u00EDa y ubicaci\u00F3n.", onCloseDrawer: handleCloseModal, 
                // Props Filter
                titleSelect1: "Provincia", titleSelect2: "Municipio", titleSelect3: "Sector", regionTypeOptions1: regionOptions1, treeData: treeData, filterStatus: filterStatus, searchFilter: searchFilter, onCloseSearch: onCloseSearch, list: list, modalTitle: itemModal === null || itemModal === void 0 ? void 0 : itemModal.title, openModalDelete: openModalDelete, setOpenModalDelete: setOpenModalDelete, clickView: clickView, onSubmit: handleDelete, onClickContextMenu: onClickContextMenu, page: page, limit: limit, onChangeRowsPerPage: onChangeRowsPerPage, onChangePage: onChangePage, countPagination: countPagination })] }));
};
export default RegionAdmin;
